<template>
  <v-col class="ma-0 pa-0">
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="contracts"
      :show-select="isReservation"
      :items-per-page="5"
      item-key="id"
      mobile-breakpoint="0"
      style="background-color: transparent">
      <template v-slot:header.reservationStatus>
        <div class="d-flex align-center justify-center">
          <span>예약상태</span>
          <v-tooltip bottom nudge-bottom="4" nudge-left="100" content-class="custom-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" small class="ml-1" style="cursor: pointer">
                mdi-help-circle-outline
              </v-icon>
            </template>
            <span>예약완료된 회원은 선정 기간 종료시 자동 선정됩니다.</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:item.level="props">
        <div class="d-flex align-center">
          <div v-if="props.item.level === 'diamond'" class="mr-2">
            <diamond-icon />
          </div>
          <div v-else class="mr-2">
            <v-icon size="20" :color="props.item.level">mdi-hexagon</v-icon>
          </div>
          <div class="d-flex align-center">
            <a
              target="_blank"
              :href="`https://blog.naver.com/${props.item.outerId}`"
              style="color: rgba(0, 0, 0, 0.87)"
              class="mr-2"
              >{{ props.item.username }}</a
            >
            <v-icon v-if="props.item.type === 'insta'" small color="pink darken-2"> mdi-instagram </v-icon>
            <span v-else class="green--text font-weight-bold" style="font-size: 14px"> N </span>
          </div>
        </div>
      </template>

      <template v-slot:item.bloggerInfo="props">
        <div>
          <v-row
            @click="influencerDetailDlg(props.item?.Influencer)"
            style="color: #4770bd; padding-bottom: 4px; font-size: 13px; cursor: pointer">
            {{ props.item?.Influencer?.account || props.item.outerId }}
            <v-icon small color="#4770BD" class="ml-1">mdi-text-box-search-outline</v-icon>
          </v-row>
          <v-row v-if="props.item?.Influencer?.categories">
            <v-chip
              outlined
              x-small
              color="#34CD89"
              class="ma-0 mr-1 mb-1"
              v-for="item in Object.keys(props.item?.Influencer?.categories || {})
                .sort(function (a, b) {
                  return props.item?.Influencer?.categories[b] - props.item?.Influencer?.categories[a];
                })
                .slice(0, 2)"
              :key="item">
              {{ item + ' ' + Math.round(props.item?.Influencer?.categories[item]) + '%' }}
            </v-chip>
          </v-row>
        </div>
      </template>
      <template v-slot:item.bloggerRank="props">
        {{ props.item?.Influencer?.rank | numFormat }}
      </template>
      <template v-slot:item.bloggerVisitor="props">
        {{ props.item?.Influencer?.visitor | numFormat }}
      </template>
      <template v-slot:item.reservationStatus="props">
        <v-chip v-if="props.item.isSelectionReserved" color="green" text-color="green" small outlined>
          예약완료
        </v-chip>
        <v-chip v-else color="grey" text-color="grey" small outlined> 예약대기 </v-chip>
      </template>
      <template v-slot:no-data>
        <div class="text-center pa-4">
          {{ isReservationFilterMode ? '예약된 회원이 없습니다.' : '데이터가 없습니다.' }}
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <v-row
            v-if="isReservation && company.type === 'A' && isBeforeReviewPeriod"
            class="pa-3 align-center mx-0"
            style="background: white">
            <span class="grey--text text--darken-2">
              예약 가능 회원수
              <span class="font-weight-bold rouge--text">{{ Math.max(0, availableSlots - selected.length) }}</span>
            </span>
            <v-spacer></v-spacer>
            <span v-if="showNoSelectionMessage" class="mr-3 rouge--text caption">선택된 회원이 없습니다.</span>
            <v-btn
              @click="handleReservationCancel"
              class="reservation-btn reservation-btn--reserve mr-2"
              outlined
              flat
              tile>
              예약 취소
            </v-btn>
            <v-btn
              @click="handleReservationConfirm"
              class="reservation-btn reservation-btn--primary"
              flat
              tile
              :disabled="availableSlots < selected.length">
              {{ selected.length > 0 ? selected.length + '명 예약' : '예약' }}
            </v-btn>
          </v-row>

          <!-- 기본 버튼들과 페이지네이션 영역 -->
          <div class="mt-2" style="position: absolute">
            <!-- 선정기간 전: 선택 예약/선택 취소 버튼 표시 -->
            <v-btn
              v-if="company.type === 'A' && isBeforeReviewPeriod"
              @click="toggleReservationMode"
              :class="['reservation-btn', isReservation ? 'reservation-btn--cancel' : 'reservation-btn--reserve']"
              outlined
              flat
              tile>
              {{ isReservation ? '선택 취소' : '선택 예약' }}
            </v-btn>
          </div>
        </div>
      </template>
    </v-data-table>
    <v-row justify="center">
      <InfluencerDetail v-model="openInfluencerDetail" :openInfluencer="openInfluencer"> </InfluencerDetail>
    </v-row>

    <!-- <v-row justify="center" align="center">
      <v-dialog v-model="showAcceptDlg" content-class="white-two" max-width="522px">
        <v-card class="pa-4">
          <v-card-title>
            <div>
              <v-icon color="default" @click="showAcceptDlg = false">close</v-icon><br />
              <h2 class="mt-2 font-weight-bold headline">수락 완료하시겠습니까?</h2>
            </div>
          </v-card-title>
          <v-card-text class="font-size:14px;color:#484848;">
            <v-row class="mt-2"> 수락하면 캠페인이 시작되며, 추가로 인원을 선택하실 수 없습니다. </v-row>
          </v-card-text>
          <v-card-actions style="padding: 16px 0 0 0">
            <v-spacer></v-spacer>
            <v-btn tile class="rouge white-two--text" @click="accept()" width="80">수락</v-btn>
            <v-btn color="rouge" tile outlined flat @click="showAcceptDlg = false" width="80">취소</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row> -->

    <!-- 예약 확인 다이얼로그 -->
    <v-row justify="center" align="center">
      <v-dialog v-model="showReservationConfirmDlg" content-class="white-two" max-width="522px">
        <v-card class="pa-4">
          <v-card-title>
            <div>
              <v-icon color="default" @click="showReservationConfirmDlg = false">close</v-icon><br />
              <h2 class="mt-2 font-weight-bold headline">선정 예약 하시겠습니까?</h2>
            </div>
          </v-card-title>
          <v-card-text class="font-size:14px;color:#484848;">
            <v-row class="mt-2"> 선택된 회원은 예약완료 상태로 변경되며, 선정 기간 종료시 자동 선정됩니다. </v-row>
          </v-card-text>
          <v-card-actions style="padding: 16px 0 0 0">
            <v-spacer></v-spacer>
            <v-btn color="rouge" tile outlined flat @click="showReservationConfirmDlg = false" width="80">취소</v-btn>
            <v-btn tile class="rouge white--text ml-2" @click="confirmReservationWithModal()" width="80">예약</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 예약 취소 다이얼로그 -->
    <v-row justify="center" align="center">
      <v-dialog v-model="showReservationCancelDlg" content-class="white-two" max-width="522px">
        <v-card class="pa-4">
          <v-card-title>
            <div>
              <v-icon color="default" @click="showReservationCancelDlg = false">close</v-icon><br />
              <h2 class="mt-2 font-weight-bold headline">예약을 취소 하시겠습니까?</h2>
            </div>
          </v-card-title>
          <v-card-text class="font-size:14px;color:#484848;">
            <v-row class="mt-2"> 선택된 회원은 예약대기 상태로 즉시 변경됩니다. </v-row>
          </v-card-text>
          <v-card-actions style="padding: 16px 0 0 0">
            <v-spacer></v-spacer>
            <v-btn color="rouge" tile outlined flat @click="showReservationCancelDlg = false" width="80">취소</v-btn>
            <v-btn tile class="rouge white--text ml-2" @click="cancelReservationWithModal()" width="80">확인</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-col>
</template>

<script>
import companyMixin from '@/components/shared/companyMixin';
import InfluencerDetail from '@/components/campaign/dialog/InfluencerDetail.vue';

export default {
  name: 'Apply',
  components: {
    diamondIcon: () => import('@/assets/img/regads/diamond.svg'),
    InfluencerDetail,
  },
  mixins: [companyMixin],
  props: ['contracts', 'option', 'tap', 'adsPayments', 'isReservationFilterMode'],
  data() {
    return {
      headers: [
        { text: '등급 ∙ 회원명', value: 'level', sortable: false, width: 130 },
        { text: '블로거 정보', align: 'left', value: 'bloggerInfo', sortable: false, width: 200 },
        { text: '국내 순위', align: 'center', value: 'bloggerRank', sortable: false },
        { text: '일방문자', align: 'center', value: 'bloggerVisitor', sortable: false },
        { text: '예약상태', value: 'reservationStatus', sortable: false, align: 'center', width: 120 },
      ],
      selected: [],
      contract: {},
      rowsPerPage: 5,
      openInfluencer: {},
      openInfluencerDetail: false,
      applyList: [],
      showReservationConfirmDlg: false,
      showReservationCancelDlg: false,
      reservedContracts: [],
      isReservation: false,
      showNoSelectionMessage: false,
    };
  },
  computed: {
    // 예약 가능 인원수
    availableSlots: function () {
      const totalSlots = this.curAdsPayment?.number || this.company.naver?.number;
      const reservedCount = this.contracts.filter(contract => contract.isSelectionReserved).length;
      return totalSlots - reservedCount;
    },
    // 선정기간 종료 10분 전 체크
    isBeforeReviewPeriod: function () {
      return this.checkIsBeforeReviewPeriod();
    },

    curAdsPayment: function () {
      return this.adsPayments.find(adsPayment => {
        return this.$moment().isBetween(
          this.$moment(adsPayment.adsStart),
          this.$moment(adsPayment.nextPaidAt),
          'days',
          '[)'
        );
      });
    },
  },
  methods: {
    // 실시간으로 모집기간 체크하는 메서드
    checkIsBeforeReviewPeriod() {
      //  테스트용 임시 설정
      // const testDeadline = this.$moment().startOf('day').add(13, 'hours').add(27, 'minutes');
      // return this.$moment().isBefore(testDeadline);

      const periodApply = this.curAdsPayment?.periodApply ?? this.company.periodApply ?? 0;
      // 2025.8.21 기준 peridAccept의 기본값을 0으로한다면 Ads의 peridAccpet, Ads_payments의 peridAccept 둘다 0을 기본값으로 해야함
      const periodAccept = this.curAdsPayment?.periodAccept ?? this.company.periodAccept ?? 0;

      const reviewEndTime = this.$moment(
        this.curAdsPayment?.adsStart || this.company.naver.payInfo_startPaidAt || this.company.naver.startDate
      )
        .startOf('day')
        .add(periodApply + periodAccept + 1, 'days') // 선정기간 마지막날 자정 기준
        .subtract(10, 'minutes');

      return this.$moment().isBefore(reviewEndTime);
    },

    async influencerDetailDlg(item) {
      this.openInfluencerDetail = true;
      this.openInfluencer = item;
    },
    toggleReservationMode() {
      this.isReservation = !this.isReservation;
      this.selected = [];
      this.showNoSelectionMessage = false;
    },

    handleReservationCancel() {
      if (this.selected.length === 0) {
        this.showNoSelectionMessage = true;
        return;
      }
      this.showReservationCancelDlg = true;
    },

    handleReservationConfirm() {
      if (this.selected.length === 0) {
        this.showNoSelectionMessage = true;
        return;
      }
      this.showReservationConfirmDlg = true;
    },

    cancelReservationWithModal() {
      if (this.selected.length === 0) {
        return;
      }
      this.showReservationCancelDlg = false;
      this.cancelReservation();
    },
    confirmReservationWithModal() {
      if (this.selected.length === 0) {
        return;
      }
      this.showReservationConfirmDlg = false;
      this.confirmReservation();
    },
    async confirmReservation() {
      // 선정기간 종료 10분 전 최종 체크
      if (!this.checkIsBeforeReviewPeriod()) {
        alert('선정 예약이 불가합니다. 페이지를 새로고침합니다.');
        window.location.reload();
        return;
      }

      // 이미 예약된 회원이 있는지 체크
      const alreadyReserved = this.selected.filter(contract => contract.isSelectionReserved);

      if (alreadyReserved.length > 0) {
        alert(`이미 예약된 회원이 ${alreadyReserved.length}명 포함되어 있습니다.`);
        return;
      }
      const contractIds = this.selected.map(contract => contract.id);

      try {
        await this.axios.post('/contract/reserve-selection', {
          contractIds,
        });
        // 로컬 상태 업데이트
        this.reservedContracts = [...this.selected];

        // 부모 컴포넌트에 알림
        this.$emit('complete');

        // 성공 메시지
        alert(`${this.selected.length}명의 블로거가 예약되었습니다.`);

        // 선택 초기화 및 예약 모드 종료
        this.selected = [];
        this.isReservation = false;
      } catch (e) {
        console.error('예약 실패:', e);
        alert('예약 처리 중 오류가 발생했습니다.');
      }
    },
    async cancelReservation() {
      // 선정기간 종료 10분 전 최종 체크
      if (!this.checkIsBeforeReviewPeriod()) {
        alert('선정 취소가 불가합니다. 페이지를 새로고침합니다.');
        window.location.reload();
        return;
      }

      // 예약되지 않은 회원이 있는지 체크
      const notReserved = this.selected.filter(contract => !contract.isSelectionReserved);

      if (notReserved.length > 0) {
        alert(`예약되지 않은 회원이 ${notReserved.length}명 포함되어 있습니다.`);
        return;
      }

      const contractIds = this.selected.map(contract => contract.id);

      try {
        await this.axios.delete('/contract/reserve-selection', {
          data: { contractIds },
        });
        // 취소 메시지
        alert(`${this.selected.length}명의 블로거가 예약 취소되었습니다.`);
        this.$emit('complete');
        this.selected = [];
        this.isReservation = false;
      } catch (e) {
        console.error('예약 취소 실패:', e);
        alert('예약 취소 처리 중 오류가 발생했습니다.');
      }
    },
  },

  created() {
    // 기존 선택된 사용자 유지 (매장의 경우 수락하기 위해 필요)
    // const selectedUser = this.contracts.filter(c => !!c.selectedAt);
    // this.selected = selectedUser;
  },

  watch: {
    selected(newVal) {
      // 회원을 선택하면 에러 메시지 숨기기
      if (newVal.length > 0 && this.showNoSelectionMessage) {
        this.showNoSelectionMessage = false;
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-expansion-panel__header {
  padding: 0px;
}

::v-deep .v-text-field--outline.v-text-field--single-line input {
  margin-top: 0;
}

::v-deep .v-text-field--outline.v-text-field--single-line .v-input__slot {
  min-height: 40px;
  border-radius: 4px;
  border: solid 1px #c2c2c2;
  border: solid 1px var(--pinkish-grey-color);
}

::v-deep .v-label {
  font-size: 14px;
}

.circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

/* 선택 예약 버튼 커스텀 스타일 */
.reservation-btn {
  padding: 8px 16px !important;
  border-radius: 4px !important;
  font-weight: 500 !important;
  letter-spacing: normal !important;
  text-transform: none !important;
  height: 36px !important;
  font-size: 14px !important;
  min-width: auto !important;
  margin-left: 0px !important;
}

/* 예약/선택 예약 버튼 (빨간색 테두리) */
.reservation-btn--reserve {
  border: 1px solid #bd1328 !important;
  color: #bd1328 !important;
  background: white !important;
}

.reservation-btn--reserve:hover {
  background: rgba(189, 19, 40, 0.04) !important;
}

.reservation-btn--reserve:disabled {
  opacity: 0.6 !important;
}

/* 예약 취소/선택 취소 버튼 (회색 테두리) */
.reservation-btn--cancel {
  border: 1px solid #757575 !important;
  color: #757575 !important;
  background: white !important;
}

.reservation-btn--cancel:hover {
  background: rgba(117, 117, 117, 0.04) !important;
}
.reservation-btn--primary {
  color: white !important;
  background: var(--primary-1) !important;
  background: #bd1328 !important;
}
.reservation-btn--primary:hover {
  background: #bd1328 !important;
}

/* 테이블 마지막 행 스타일 */
::v-deep .v-data-table tbody tr:last-child td {
  border-bottom: 1px solid #e0e0e0 !important;
}

/* 예약 모드일 때 footer 스타일 */
::v-deep .v-data-footer {
  border-top: none !important;
}

/* 체크박스 열 너비 조정 */

::v-deep .v-data-table__checkbox {
  width: 24px !important;
  min-width: 24px !important;
}

::v-deep .v-simple-checkbox {
  width: 18px !important;
}

::v-deep th.text-start:first-child,
::v-deep td:first-child {
  width: 40px !important;
  max-width: 40px !important;
  padding: 0 8px !important;
}

.custom-tooltip {
  border-radius: 16px !important;
  font-size: 12px !important;
  padding: 8px !important;
}
</style>
